<template>
  <div class="header-assets" @click="navigateToAssets">
    <div class="assets-icon">
      <i class="fas fa-wallet"></i>
    </div>
    <div class="assets-item">
      <span class="assets-label">企业资产</span>
      <span class="assets-value">¥{{ formattedBalance }}</span>
    </div>
  </div>
</template>
<script>
import { getPlatformAccount } from '@/api/product/acct'

export default {
  data() {
    return {
      accountBalance: 0
    }
  },
  computed: {
    formattedBalance() {
      const num = Number(this.accountBalance) || 0
      return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  },
  mounted() {
    this.fetchPlatformAccount()
  },
  methods: {
    navigateToAssets() {
      this.$router.push({ path: '/entAssets' })
    },
    // 获取企业平台账号信息（可用余额）
    fetchPlatformAccount() {
      getPlatformAccount().then(res => {
        // 兼容直接返回对象与 { data: {...} } 两种结构
        const data = res && res.data !== undefined ? res.data : (res || {})
        this.accountBalance = data.availableBalance != null ? Number(data.availableBalance) : 0
      }).catch(err => {
        console.error('获取企业平台账号信息失败：', err)
      })
    }
  },
}
</script>
<style scoped lang="scss">
.header-assets {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  padding: 6px 16px 6px 12px;
  cursor: pointer;
}

.assets-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}

.assets-item {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.assets-label {
  font-size: 11px;
  color: #6B7280;
}

.assets-value {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
  letter-spacing: 0.3px;
}

.header-divider {
  width: 1px;
  height: 28px;
  background: #E5E7EB;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.15s;
  position: relative;
}

.icon-btn:hover {
  background: #F3F4F6;
  color: #374151;
}
</style>
